/* eslint-disable no-console */
import { Plugins } from '@leverege/plugin';
const list = () => {
  const rts = Plugins.get('Route');
  console.log('Dynamic Route List');
  // console.table( rts, [ 'id', 'path', 'exact', 'client' ] ) 

  console.table(rts.reduce((accum, item, idx) => {
    // eslint-disable-next-line no-param-reassign
    const str = Object.entries(item.matches || {}).map(([k, v]) => `${k}:${v}`).join(' ');
    // eslint-disable-next-line no-param-reassign
    accum[item.id || idx] = {
      path: item.path,
      exact: item.exact,
      matches: str
    };
    return accum;
  }, {}));
};
export default {
  list
};